var _rect, _polyline, _line, _line2, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 70,
    height: 50,
    rx: 4,
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "10,25 45,55 80,25",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 75,
    x2: 35,
    y2: 50,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 75,
    x2: 55,
    y2: 50,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 30,
    r: 15,
    fill: "#000"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 37,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "@")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationManagement);
export default __webpack_public_path__ + "static/media/communication-management.589e7de951e9626391ef6c5f8cc3d31c.svg";
export { ForwardRef as ReactComponent };